;( function( $, undefined )
{

    $.fn.PrivateMessagesList = function()
    {
        var $oldList    = $( '.NotesList' )
          , $oldWrapper = $( '#old-message-list' )
          , $newList    = $( '#pm-list' );

        $oldWrapper.find( '.checkAll' ).click( function( e )
        {
            e && e.preventDefault();

            $newList.find( 'input' ).prop( 'checked', true ).closest( 'li' ).addClass( 'selected' );
        } );

        $oldWrapper.find( '.uncheckAll' ).click( function( e )
        {
            e && e.preventDefault();

            $newList.find( 'input' ).prop( 'checked', false ).closest( 'li' ).removeClass( 'selected' );
        } );

        $('.lia-menu-navigation-wrapper.lia-menu-action').after('<div id="dropdown-modal"></div>');

        $newList.find( '.no-author' ).each( function()
        {
            var id        = $( this ).data( 'note' )
              , textLimit = $( this ).data( 'title-limit' )
              , $input    = $oldList.find( 'input[type="checkbox"][value="' + id + '"]' )
              , $old      = $input.closest( 'tr' )
              , users     = []
              , usernames = [];

            $input.remove();

            $old.find( '.UserName' ).each( function()
            {
                var $this = $( this )
                  , href  = $this.find( 'a' ).attr( 'href' )
                  , parts = href.split( '/' )
                  , id    = parts[ parts.length - 1 ]
                  , name  = $this.find( 'span' ).text();

                users.push( {
                    name : name,
                    href : href,
                    id   : id
                } );

                usernames.push( name );
            } );

            usernames = usernames.join( ', ' );

            if( usernames.length > textLimit )
            {
                usernames = usernames.substr( 0, textLimit ) + '...';
            }

            $( this ).find( 'h4' ).text( usernames );

        } ).end().find( '.check' ).on( 'click', function( e )
        {
            e && e.preventDefault();

            var $check = $( this ).find( 'input' );

            $( this ).closest( 'li' ).toggleClass( 'selected' );
            $check.prop( 'checked', !$check.prop( 'checked' ) );
        } );



        var $success  = $( '.lia-component-quilt-header' ).find( 'a[name="feedback-success"]' )
          , $feedback = $( '#pm-feedback' );

        if( $success.size() )
        {
            var $text = $success.next().find( '.lia-text' );

            $text.find( 'ul' ).remove();
            $feedback.children().text( $text.text() );
            $feedback.addClass( 'message-success' );

            $feedback.removeClass( 'hide' );
        }
    };

} )( jQuery );
